import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "c-arxiv__loader" };
const _hoisted_2 = ["href", "title"];
import { onMounted, onBeforeMount } from "vue";
import { useEntries } from "./features/useEntries";
import { useConfig } from "./features/useConfig";
import ArxivLink from "./components/ArxivLink.vue";
import Loader from "./components/TheLoader.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const { fetchEntries, entries, loading } = useEntries();
        const { setConfig } = useConfig();
        onBeforeMount(() => {
            setConfig({
                apiUrl: window.arxivConfig?.apiUrl,
                arxivLink: window.arxivConfig?.arxivLink,
                linkText: window.arxivConfig?.linkText,
                linkTitle: window.arxivConfig?.linkTitle,
            });
        });
        onMounted(async () => {
            await fetchEntries(window.arxivConfig?.apiUrl);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(loading))
                    ? (_openBlock(), _createBlock(Loader, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(entries), (entry) => {
                                return (_openBlock(), _createElementBlock("li", null, [
                                    _createElementVNode("a", {
                                        href: entry.id,
                                        class: "is-internal",
                                        target: "_blank",
                                        title: entry.title,
                                        rel: "noopener"
                                    }, _toDisplayString(entry.title), 9 /* TEXT, PROPS */, _hoisted_2)
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createVNode(ArxivLink)
                    ], 64 /* STABLE_FRAGMENT */))
            ]));
        };
    }
});
